class UrlsService{
    private _startDate: string;
    private _endDate: string;
    private _comparison:number

    public set endDate(value: string) {
        this._endDate = value;
    }

    public set startDate(value: string) {
        this._startDate = value;
    }
    public set comparison(value: number) {
        this._comparison = value;
    }

    public login(): string {
        return "/login"
    }

    public app(): string {
        return "/"
    }

    public home(): string{
        return "/home"
    }

    private _getDatesQueryParams(shouldAddDates): string {
        if (!shouldAddDates) {
            return "";
        }

        if (!(this._startDate && this._endDate)) {
            return ""
        }
        return `?startDate=${this._startDate}&endDate=${this._endDate}&comparison=${this._comparison}`
    }

}

const urlService = new UrlsService();

export {urlService}